import React from 'react'
import createIcon from '@/lib/create-icon'

export const CheckCircleFilledIcon = createIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_10741_189736)">
      <circle cx="7.99992" cy="7.99998" r="6.66667" fill="#B3B3B3" stroke="#B3B3B3" strokeWidth="2" />
      <path d="M11.3334 6L6.20521 10.6667L4.66675 9" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_10741_189736">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>,

)
